import styled from "styled-components";

export const BubbleFloatStyled = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    pointer-events: none;
    opacity: ${({theme})=> theme === 'dark' ? '0.2' : '0.4'};
    animation: floatDriftLoop 20s linear infinite;
    //
    img {
        width: 300px;
        height: auto;
    }
    @keyframes floatDriftLoop {
        0% {
            transform: translateY(0) rotate(0deg) scale(1);
        }
        20% {
            transform: translateY(10vh) rotate(2deg) scale(1.05);
        }
        40% {
            transform: translateY(20vh) rotate(-2deg) scale(1.1);
        }
        60% {
            transform: translateY(10vh) rotate(1deg) scale(1.08);
        }
        80% {
            transform: translateY(5vh) rotate(-1deg) scale(1.03);
        }
        100% {
            transform: translateY(0) rotate(0deg) scale(1);
        }
    }

    @media only screen and (min-width: 992px) {
        img {
            width: 350px;
            height: auto;
        }
    }
`;


export const BubbleImageStyled = styled.div`
    width: 180px;
    height: 180px;
    box-shadow: ${({ theme }) =>
            theme === 'dark'
                    ? `
      0px 4px 8px rgba(111, 203, 209, 0.25),
      0px 8px 16px rgba(111, 203, 209, 0.15)
    `
                    : `
      0px 4px 8px rgba(0, 0, 0, 0.15),
      0px 8px 16px rgba(0, 0, 0, 0.08)
    `
    };    border-radius: 50%;
    opacity: 0.8;
    animation: wobble 3s ease-in-out infinite;
    overflow: hidden;
    img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;

    }
    


    @keyframes wobble {
        0% {
            border-radius: 50% 50% 50% 50%;
        }
        25% {
            border-radius: 48% 52% 55% 45%;
        }
        50% {
            border-radius: 55% 45% 48% 52%;
        }
        75% {
            border-radius: 52% 48% 50% 50%;
        }
        100% {
            border-radius: 50% 50% 50% 50%;
        }
    }
`;


